module.exports = "img/flags/SA.b02ee99.png";